module.exports = __webpack_public_path__ + "static/media/SEO.1f9c19e1.png";